// extracted by mini-css-extract-plugin
export default {"messageWrapper":"styles_messageWrapper__f68od"};